function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.6654 5.50021C13.6654 6.80202 12.5858 7.85735 11.2539 7.85735C9.92204 7.85735 8.84236 6.80202 8.84236 5.50021C8.84236 4.1984 9.92204 3.14307 11.2539 3.14307C12.5858 3.14307 13.6654 4.1984 13.6654 5.50021ZM11.2536 16.8931C14.1313 16.8931 17.3949 17.9459 18.7454 18.8574H3.76172C5.11218 17.9459 8.3758 16.8931 11.2536 16.8931Z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.2538 11C14.3567 11 16.8808 8.53286 16.8808 5.5C16.8808 2.46714 14.3567 0 11.2538 0C8.151 0 5.62692 2.46714 5.62692 5.5C5.62692 8.53286 8.151 11 11.2538 11ZM11.2538 3.14286C12.5882 3.14286 13.6654 4.19571 13.6654 5.5C13.6654 6.80429 12.5882 7.85714 11.2538 7.85714C9.91946 7.85714 8.84231 6.80429 8.84231 5.5C8.84231 4.19571 9.91946 3.14286 11.2538 3.14286ZM11.2538 13.75C7.49185 13.75 0 15.5886 0 19.25V22H22.5077V19.25C22.5077 15.5886 15.0158 13.75 11.2538 13.75ZM3.762 18.8571C5.11246 17.9457 8.37608 16.8929 11.2538 16.8929C14.1316 16.8929 17.3952 17.9457 18.7457 18.8571H3.762ZM22.572 13.8443C24.4369 15.1643 25.7231 16.9243 25.7231 19.25V22H32.1538V19.25C32.1538 16.0757 26.5269 14.2686 22.572 13.8443ZM20.9 11C24.0028 11 26.5269 8.53286 26.5269 5.5C26.5269 2.46714 24.0028 0 20.9 0C20.0318 0 19.228 0.204286 18.4885 0.55C19.5013 1.94857 20.0962 3.66143 20.0962 5.5C20.0962 7.33857 19.5013 9.05143 18.4885 10.45C19.228 10.7957 20.0318 11 20.9 11Z",
  fill: "currentColor"
});

var SvgFriends = function SvgFriends(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 33 22",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFriends, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/friends.41946c91.svg";
export { ForwardRef as ReactComponent };